<script setup lang="ts">
  /**
   * PortalFooter — rail footer for the portal homepage. Carries the same
   * items as the classic footer: the Settings popover (theme picker, AI
   * summaries), consent revocation ("Privacy and Cookie Settings"),
   * Privacy Policy, Terms of Use, and the copyright line — stacked for
   * the Yahoo-style right rail. Registered into lego-land's component
   * registry at boot (see plugins/legoland-registry.ts).
   */
  import GoogleConsentRevocationLink from '../Footer/GoogleConsentRevocationLink.vue'

  withDefaults(defineProps<{ brandName?: string }>(), {
    brandName: 'OneNews',
  })

  const { legalLinks } = useGlobalLayoutSettings()
  const { privacyPolicyUrl, termsUrl } = legalLinks

  const { t } = useI18n()
  const year = new Date().getFullYear()

  const siteSettingsStore = useSiteSettingsStore()
  const { data: siteSettings } = storeToRefs(siteSettingsStore)
</script>

<template>
  <footer class="px-4 py-3">
    <div
      class="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[13px] text-content-secondary"
    >
      <SettingsButton v-if="siteSettings.userSettings" />
      <GoogleConsentRevocationLink
        color="text-content-secondary"
        variant="text-[13px]"
      />
    </div>

    <p class="flex flex-wrap justify-center gap-x-3 gap-y-1 pt-1 text-center">
      <a
        :href="privacyPolicyUrl"
        target="_blank"
        class="text-[13px] text-content-secondary hover:underline"
      >
        {{ t('Privacy Policy') }}
      </a>
      <a
        :href="termsUrl"
        target="_blank"
        class="text-[13px] text-content-secondary hover:underline"
      >
        {{ t('Terms of Use') }}
      </a>
    </p>

    <p class="pt-2 text-center text-[13px] text-content-secondary">
      &copy; {{ year }} {{ brandName }}. {{ t('All rights reserved.') }}
    </p>
  </footer>
</template>
